import React, { useState } from 'react';
import { NewContainerIcons } from '@/assets';
import { fDate } from '@/actions/Helper';
import CountUpDown from '@/components/CountUpDown';
import IconButton from '@/ctComponents/IconButton';

export const SearchContainerCard = ({
  containerItem,
  openReserve,
  handleAddToFavList,
  savedList,
  noImage = false,
  setReserveInformation,
  reservedItem,
  noCountChange = false,
}) => {
  const [imageLoading, setImageLoading] = useState(true);

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  return (
    <div>
      <div
        className={` relative overflow-hidden shadow-container-card rounded ${
          noImage ? 'p-3' : 'px-5 py-1 sm:pl-0'
        } flex sm:flex-row flex-col justify-center sm:justify-start items-center gap-1`}>
        {!noImage && (
          <img
            className={`scale-75 lg:scale-100 sm:-ml-47 w-full sm:w-1/3 md:w-1/2 lg:w-1/2 xl:w-1/2  ${
              imageLoading && 'grayscale-1 animate-pulse'
            }`}
            src={
              imageLoading
                ? NewContainerIcons.defaultOrangeContainer
                : NewContainerIcons[
                    containerItem.cabin.company.name.replace(/\s+/, '')
                  ] || NewContainerIcons.defaultOrangeContainer
            }
            alt="apm"
            onLoad={handleImageLoad}
          />
        )}
        <div
          className={`${
            noImage ? 'py-0 space-y-1' : 'py-4  space-y-1'
          } w-full`}>
          <div className="flex justify-between items-center">
            <span className="text-text-gray-light text-11">SSL</span>
            <span className="text-gray-600 font-bold text-11">
              {containerItem.cabin.company.name}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-text-gray-light text-11">Size</span>
            <span className="text-gray-600 font-bold text-11">
              {containerItem.cabin.specifications.size_type}
            </span>
          </div>

          <div
            className="flex justify-between items-center"
            style={{ margin: 0 }}>
            <span className="text-text-gray-light text-11">Number</span>
            <CountUpDown
              currentValue={Number(
                containerItem.id === reservedItem?.id
                  ? reservedItem?.count
                  : containerItem.count_available
              )}
              maxValue={containerItem.count_available}
              minValue={1}
              onIncrement={() => {
                const currentValue = Number(
                  containerItem.id === reservedItem?.id
                    ? reservedItem?.count
                    : containerItem.count_available
                );
                const maxValue = containerItem.count_available;

                if (currentValue < maxValue) {
                  setReserveInformation((pre) => ({
                    ...pre,
                    item: {
                      ...containerItem,
                      count: currentValue + 1,
                    },
                  }));
                }
              }}
              onDecrement={() => {
                const currentValue = Number(
                  containerItem.id === reservedItem?.id
                    ? reservedItem?.count
                    : containerItem.count_available
                );
                const minValue = 1;
                if (currentValue > minValue) {
                  setReserveInformation((pre) => ({
                    ...pre,
                    item: {
                      ...containerItem,
                      count: currentValue - 1,
                    },
                  }));
                }
              }}
              disabled={noCountChange}
              valueClassName="px-3 text-center text-gray-600 font-bold text-11"
            />
          </div>

          <div
            className="flex justify-between items-center"
            style={{ margin: 0 }}>
            <span className="text-text-gray-light text-11">Location</span>
            <span className="text-gray-600 font-bold text-11">
              {containerItem.address.city}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-text-gray-light text-11">
              Num of Own Chassis
            </span>
            <span className="text-gray-600 font-bold text-11">
              {containerItem.own_chases_count}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-text-gray-light text-11">
              Num of Pool Chassis
            </span>
            <span className="text-gray-600 font-bold text-11">
              {containerItem.pool_chases_count}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-text-gray-light text-11">Flip Available</span>
            <span className="text-gray-600 font-bold text-11">
              {containerItem.flip_available ? 'Yes' : 'No'}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-text-gray-light text-11">Last Update</span>
            <span className="text-gray-600 font-bold text-11">
              {fDate(containerItem.updated_at)}
            </span>
          </div>
          <hr className="border-border-tertiary border-solid " />
          <div className={`flex items-center gap-2 `} style={{ marginTop: 6 }}>
            {' '}
            <IconButton
              icon={savedList.includes(containerItem) ? 'tickICon' : null}
              text={
                savedList.includes(containerItem) ? 'Saved' : 'Add to Save List'
              }
              onClick={() => handleAddToFavList(containerItem)}
              color={savedList.includes(containerItem) ? '#1FC16B' : '#525866'}
              style={{
                border: savedList.includes(containerItem)
                  ? '1px solid #C2F5DA'
                  : '1px solid #E1E4EA',
                height: 32,
                flex: 1,
                fontSize: 11,
              }}
              textStyle={{
                fontSize: 11,
              }}
            />
            <IconButton
              color="#fff"
              icon="reserve"
              text="Reserve"
              textStyle={{
                fontSize: 11,
              }}
              style={{
                backgroundColor: '#131517',
                height: 32,
                flex: 1,
                fontSize: 11,
              }}
              onClick={() => openReserve(containerItem)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
